import React, { FC } from 'react';
import ReactPDF, { View } from '@react-pdf/renderer';
import { PAPER_SIZE, PDFEntitlementIcon } from '../../../../types/enums';
import PDFUtils from '../../../utils/pdfUtils';
import { Style } from '@react-pdf/types';

type Props = {
  icons: Array<PDFEntitlementIcon>;
  isCustomBadge: boolean;
  pdfStyles: ReactPDF.Styles;
  containerStyles?: Style;
  paperSize: PAPER_SIZE;
};

export const BadgeIcons: FC<Props> = ({ paperSize, icons, isCustomBadge, pdfStyles, containerStyles = {} }) => {
  const getIconTopPositionIfIs4x10Inches = (positionInPercents: string, count: number) => {
    const percentNumber = +positionInPercents.split('%')[0];
    if (isCustomBadge) {
      return { top: `${percentNumber - count}%` };
    }
    return { top: `${percentNumber}%` };
  };

  const getTopPositionForIcons = () => {
    let threeIcon4x10Decreaser = 5;
    let twoIcon4x10Decreaser = 4;
    let oneIcon4x10Decreaser = 3;

    if(paperSize === PAPER_SIZE.W298_X_100) {
      threeIcon4x10Decreaser = -1;
      twoIcon4x10Decreaser = -0.5;
      oneIcon4x10Decreaser = 0.5;
    }

    if (icons.length === 3) {
      return {
        ...pdfStyles.threeIconContainer,
        ...getIconTopPositionIfIs4x10Inches(pdfStyles.threeIconContainer.top as string, threeIcon4x10Decreaser)
      };
    }
    if (icons.length === 2) {
      return {
        ...pdfStyles.twoIconContainer,
        ...getIconTopPositionIfIs4x10Inches(pdfStyles.twoIconContainer.top as string, twoIcon4x10Decreaser)
      };
    }
    return {
      ...pdfStyles.oneIconContainer,
      ...getIconTopPositionIfIs4x10Inches(pdfStyles.oneIconContainer.top as string, oneIcon4x10Decreaser)
    };
  };

  return (
    <View style={[pdfStyles.iconContainer, getTopPositionForIcons(), containerStyles]}>
      {icons.map((name) => {
        const Component = PDFUtils.getIconByName(name);
        return Component && <Component />;
      })}
    </View>
  );
};
